(() => {
  const formatMoney = (cents) => {
    const value = Number(cents || 0) / 100;
    return `${new Intl.NumberFormat('ro-RO', { maximumFractionDigits: value % 1 ? 2 : 0 }).format(value)} lei`;
  };

  document.querySelectorAll('[data-vrp-product]').forEach((section) => {
    const mainImage = section.querySelector('[data-vrp-main-image]');
    const mainImageButton = section.querySelector('[data-vrp-open-lightbox]');
    const galleryButtons = [...section.querySelectorAll('[data-vrp-gallery-image]')];
    const thumbs = section.querySelector('[data-vrp-thumbs]');
    const thumbsUp = section.querySelector('[data-vrp-thumbs-up]');
    const thumbsDown = section.querySelector('[data-vrp-thumbs-down]');
    const mobileGallery = window.matchMedia('(max-width: 700px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const updateThumbControls = () => {
      if (!thumbs || !thumbsUp || !thumbsDown || mobileGallery.matches) return;
      const maxScroll = Math.max(0, thumbs.scrollHeight - thumbs.clientHeight);
      thumbsUp.disabled = thumbs.scrollTop <= 2;
      thumbsDown.disabled = thumbs.scrollTop >= maxScroll - 2;
    };

    const moveThumbs = (direction) => {
      if (!thumbs || mobileGallery.matches) return;
      const firstThumb = galleryButtons[0];
      const gap = Number.parseFloat(window.getComputedStyle(thumbs).rowGap || '0');
      const distance = (firstThumb?.getBoundingClientRect().height || 95) + gap;
      thumbs.scrollBy({ top: direction * distance, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    };

    thumbsUp?.addEventListener('click', () => moveThumbs(-1));
    thumbsDown?.addEventListener('click', () => moveThumbs(1));
    thumbs?.addEventListener('scroll', updateThumbControls, { passive: true });
    let thumbTouchStart = null;
    let thumbTouchAxis = null;
    let suppressThumbClick = false;
    thumbs?.addEventListener('touchstart', (event) => {
      if (!mobileGallery.matches || event.touches.length !== 1) return;
      const touch = event.touches[0];
      thumbTouchStart = { x: touch.clientX, y: touch.clientY, scroll: thumbs.scrollLeft };
      thumbTouchAxis = null;
    }, { passive: true });
    thumbs?.addEventListener('touchmove', (event) => {
      if (!thumbTouchStart || event.touches.length !== 1) return;
      const touch = event.touches[0];
      const distanceX = touch.clientX - thumbTouchStart.x;
      const distanceY = touch.clientY - thumbTouchStart.y;
      if (!thumbTouchAxis && Math.hypot(distanceX, distanceY) > 7) {
        thumbTouchAxis = Math.abs(distanceX) > Math.abs(distanceY) * 1.15 ? 'horizontal' : 'vertical';
      }
      if (thumbTouchAxis === 'horizontal') thumbs.scrollLeft = thumbTouchStart.scroll - distanceX;
    }, { passive: true });
    const finishThumbTouch = () => {
      if (thumbTouchAxis === 'horizontal') {
        suppressThumbClick = true;
        window.setTimeout(() => { suppressThumbClick = false; }, 400);
      }
      thumbTouchStart = null;
      thumbTouchAxis = null;
    };
    thumbs?.addEventListener('touchend', finishThumbTouch, { passive: true });
    thumbs?.addEventListener('touchcancel', finishThumbTouch, { passive: true });
    thumbs?.addEventListener('click', (event) => {
      if (!suppressThumbClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressThumbClick = false;
    }, true);
    window.addEventListener('resize', updateThumbControls, { passive: true });
    mobileGallery.addEventListener?.('change', updateThumbControls);
    window.requestAnimationFrame(updateThumbControls);
    window.addEventListener('load', updateThumbControls, { once: true });

    const updateMainImage = (button, animate = true) => {
      galleryButtons.forEach((item) => item.setAttribute('aria-current', 'false'));
      button.setAttribute('aria-current', 'true');
      if (!mainImage) return;
      if (animate) mainImage.animate([{ opacity: 0.35 }, { opacity: 1 }], { duration: 280, easing: 'ease-out' });
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = button.dataset.vrpGalleryImage;
      mainImage.dataset.vrpLargeImage = button.dataset.vrpGalleryLarge || button.dataset.vrpGalleryImage;
      mainImage.alt = button.dataset.vrpGalleryAlt || '';
    };

    galleryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        updateMainImage(button);
      });
    });

    const lightbox = section.querySelector('[data-vrp-lightbox]');
    const lightboxImage = lightbox?.querySelector('[data-vrp-lightbox-image]');
    const previousButton = lightbox?.querySelector('[data-vrp-lightbox-prev]');
    const nextButton = lightbox?.querySelector('[data-vrp-lightbox-next]');
    let lightboxIndex = 0;
    let swipeStartX = null;
    let mainTouchStart = null;
    let mainTouchMoved = false;
    let suppressMainOpen = false;

    const showLightboxImage = (index) => {
      if (!lightboxImage || galleryButtons.length === 0) return;
      lightboxIndex = (index + galleryButtons.length) % galleryButtons.length;
      const button = galleryButtons[lightboxIndex];
      updateMainImage(button, false);
      lightboxImage.src = button.dataset.vrpGalleryLarge || button.dataset.vrpGalleryImage;
      lightboxImage.alt = button.dataset.vrpGalleryAlt || '';
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.documentElement.classList.remove('vrp-lightbox-open');
    };

    [previousButton, nextButton].forEach((button) => {
      if (button) button.hidden = galleryButtons.length < 2;
    });

    const activeGalleryIndex = () => {
      const index = galleryButtons.findIndex((button) => button.getAttribute('aria-current') === 'true');
      return index >= 0 ? index : 0;
    };

    const moveMainImage = (direction) => {
      if (galleryButtons.length < 2) return;
      const nextIndex = (activeGalleryIndex() + direction + galleryButtons.length) % galleryButtons.length;
      updateMainImage(galleryButtons[nextIndex]);
    };

    mainImageButton?.addEventListener('touchstart', (event) => {
      if (!mobileGallery.matches || event.touches.length !== 1) return;
      const touch = event.touches[0];
      mainTouchStart = { x: touch.clientX, y: touch.clientY };
      mainTouchMoved = false;
    }, { passive: true });
    mainImageButton?.addEventListener('touchmove', (event) => {
      if (!mainTouchStart || event.touches.length !== 1) return;
      const touch = event.touches[0];
      if (Math.hypot(touch.clientX - mainTouchStart.x, touch.clientY - mainTouchStart.y) > 8) {
        mainTouchMoved = true;
      }
    }, { passive: true });
    mainImageButton?.addEventListener('touchend', (event) => {
      if (!mainTouchStart || event.changedTouches.length !== 1) return;
      const touch = event.changedTouches[0];
      const distanceX = touch.clientX - mainTouchStart.x;
      const distanceY = touch.clientY - mainTouchStart.y;
      const wasMoved = mainTouchMoved;
      mainTouchStart = null;
      mainTouchMoved = false;

      if (wasMoved) {
        suppressMainOpen = true;
        window.setTimeout(() => { suppressMainOpen = false; }, 500);
      }
      if (Math.abs(distanceX) < 45 || Math.abs(distanceX) <= Math.abs(distanceY) * 1.2) return;
      moveMainImage(distanceX < 0 ? 1 : -1);
    }, { passive: true });
    mainImageButton?.addEventListener('touchcancel', () => {
      mainTouchStart = null;
      mainTouchMoved = false;
    }, { passive: true });

    mainImageButton?.addEventListener('click', (event) => {
      if (suppressMainOpen) {
        event.preventDefault();
        suppressMainOpen = false;
        return;
      }
      if (!lightbox || !lightboxImage || !mainImage) return;
      lightboxIndex = activeGalleryIndex();
      showLightboxImage(lightboxIndex);
      lightbox.hidden = false;
      document.documentElement.classList.add('vrp-lightbox-open');
      lightbox.querySelector('[data-vrp-close-lightbox]')?.focus();
    });

    previousButton?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      showLightboxImage(lightboxIndex - 1);
    });
    nextButton?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      showLightboxImage(lightboxIndex + 1);
    });
    lightbox?.querySelectorAll('[data-vrp-close-lightbox]').forEach((button) => button.addEventListener('click', closeLightbox));
    lightbox?.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse') swipeStartX = event.clientX;
    });
    lightbox?.addEventListener('pointerup', (event) => {
      if (swipeStartX === null || galleryButtons.length < 2) return;
      const distance = event.clientX - swipeStartX;
      swipeStartX = null;
      if (Math.abs(distance) < 45) return;
      showLightboxImage(lightboxIndex + (distance < 0 ? 1 : -1));
    });
    document.addEventListener('keydown', (event) => {
      if (!lightbox || lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft' && galleryButtons.length > 1) showLightboxImage(lightboxIndex - 1);
      if (event.key === 'ArrowRight' && galleryButtons.length > 1) showLightboxImage(lightboxIndex + 1);
    });

    const form = section.querySelector('[data-vrp-form]');
    const variantsNode = section.querySelector('[data-vrp-variants]');
    if (!form || !variantsNode) return;

    const variants = JSON.parse(variantsNode.textContent || '[]');
    const variantInput = form.querySelector('input[name="id"]');
    const quantityInput = form.querySelector('input[name="quantity"]');
    const price = section.querySelector('[data-vrp-price]');
    const stock = section.querySelector('[data-vrp-stock]');
    const stockText = section.querySelector('[data-vrp-stock-text]');
    const submit = form.querySelector('[data-vrp-submit]');
    const submitText = submit?.querySelector('span');
    const groups = [...section.querySelectorAll('[data-vrp-option]')];
    const availableLabel = section.dataset.vrpAvailableLabel || 'În stoc';

    const selectedOptions = () => groups.map((group) => group.querySelector('[aria-pressed="true"]')?.dataset.optionValue || '');

    const syncVariant = () => {
      const selected = selectedOptions();
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) {
        if (submit) submit.disabled = true;
        if (stock) stock.classList.add('is-unavailable');
        if (stockText) stockText.textContent = 'Combinație indisponibilă';
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (submit) submit.disabled = !variant.available;
      if (stock) stock.classList.toggle('is-unavailable', !variant.available);
      if (stockText) stockText.textContent = variant.available ? availableLabel : 'Indisponibil';
      if (submitText) submitText.textContent = variant.available ? 'Adaugă în coș' : 'Indisponibil';
      if (variant.featured_image?.src && mainImage) {
        const featuredId = String(variant.featured_image.id || '');
        const featuredPath = new URL(variant.featured_image.src, window.location.origin).pathname;
        const featuredButton = galleryButtons.find((button) => {
          if (featuredId && button.dataset.vrpGalleryImageId === featuredId) return true;
          return new URL(button.dataset.vrpGalleryImage, window.location.origin).pathname === featuredPath;
        });
        if (featuredButton) {
          updateMainImage(featuredButton);
          featuredButton.scrollIntoView({
            block: 'nearest',
            inline: 'nearest',
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        } else {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = variant.featured_image.src;
          mainImage.dataset.vrpLargeImage = variant.featured_image.src;
          mainImage.alt = `${section.querySelector('.vrp-buy h1')?.textContent.trim() || 'Produs'} — ${selected.join(', ')}`;
        }
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    groups.forEach((group) => {
      group.querySelectorAll('[data-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          group.querySelectorAll('[data-option-value]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
          button.setAttribute('aria-pressed', 'true');
          const label = group.querySelector('[data-vrp-option-label]');
          if (label) label.textContent = button.dataset.optionValue;
          syncVariant();
        });
      });
    });

    form.querySelector('[data-vrp-qty-minus]')?.addEventListener('click', () => {
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
    });
    form.querySelector('[data-vrp-qty-plus]')?.addEventListener('click', () => {
      quantityInput.value = Math.min(99, Number(quantityInput.value || 1) + 1);
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!submit || submit.disabled) return;
      submit.disabled = true;
      const original = submitText.textContent;
      submitText.textContent = 'Se adaugă…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!response.ok) throw new Error('Add to cart failed');
        const item = await response.json();
        submitText.textContent = 'Adăugat în coș';
        if (window.VidaRoiCartFeedback) {
          await window.VidaRoiCartFeedback.refreshCount();
          window.VidaRoiCartFeedback.show({ item, quantity: Number(quantityInput.value || 1), title: document.querySelector('.vrp-buy h1')?.textContent.trim() || '' });
        } else {
          document.querySelectorAll('.vr-cart-button span').forEach((counter) => {
            counter.textContent = Number(counter.textContent || 0) + Number(quantityInput.value || 1);
          });
        }
        window.setTimeout(() => {
          submit.disabled = false;
          submitText.textContent = original;
        }, 1300);
      } catch (error) {
        submit.disabled = false;
        submitText.textContent = original;
        form.submit();
      }
    });
  });
})();
